
import React from 'react';
import { TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';

const KPICard = ({ 
  title, 
  value, 
  icon, 
  positiveMetric, 
  positiveLabel, 
  negativeMetric, 
  negativeLabel, 
  bgColor,
  alertThreshold,
  isClv
}) => {
  const Icon = icon;
  const cardBgColor = bgColor || 'bg-white';
  
  // Determine if we should show an alert based on the threshold
  const showAlert = alertThreshold && parseFloat(negativeMetric) < alertThreshold;
  
  // Determine if the negative value is actually positive (for CLV)
  const isNegativePositive = negativeMetric && parseFloat(negativeMetric) >= 0;
  
  return (
    <div className={`${cardBgColor} rounded-lg shadow p-5 hover:shadow-md transition-shadow`}>
      <div className="flex justify-between items-start mb-3">
        <div>
          <p className="text-sm text-gray-500 mb-1">{title}</p>
          <h2 className="text-2xl font-semibold text-gray-900">
            {value}
            {isClv && <span className="text-sm text-gray-500 ml-1">multiplier</span>}
          </h2>
        </div>
        <div className={`p-2 ${showAlert ? 'bg-red-100' : 'bg-purple-100'} rounded-md`}>
          {Icon && <Icon size={20} className={showAlert ? 'text-red-600' : 'text-purple-600'} />}
        </div>
      </div>
      <div className="flex flex-col space-y-2">
        {positiveMetric && (
          <div className="flex items-center">
            <TrendingUp size={14} className="text-green-500 mr-1" />
            <span className="text-green-500 text-sm font-medium">{positiveMetric} {positiveLabel}</span>
          </div>
        )}
        {negativeMetric && (
          <div className="flex items-center">
            {isNegativePositive ? (
              <TrendingUp size={14} className="text-green-500 mr-1" />
            ) : (
              <TrendingDown size={14} className="text-red-500 mr-1" />
            )}
            <span className={isNegativePositive ? "text-green-500 text-sm font-medium" : "text-red-500 text-sm font-medium"}>
              {negativeMetric} {negativeLabel}
            </span>
          </div>
        )}
        {showAlert && (
          <div className="flex items-center mt-1">
            <AlertCircle size={14} className="text-red-500 mr-1" />
            <span className="text-red-500 text-xs">Below target threshold</span>
          </div>
        )}
        {isClv && (
          <div className="mt-1 text-xs text-gray-600">
            Represents customer value over projected relationship duration
          </div>
        )}
      </div>
    </div>
  );
};

export default KPICard;
